import styled from 'styled-components';

export const Input = styled.div`
  display: flex;
  align-items: center;
  background-color: white;
  justify-content: space-between;
  height: 55px;
  border: none;
  border: dotted 1px #ccc;
  border-radius: 30px;
  padding-left: 8px;
  flex: 1;
  padding-right: 8px;
`;
